export enum WritersPaymentStatusEnum {
  PENDING = 'PENDING',
  CUMULATIVE = 'CUMULATIVE',
  ACCUMULATED = 'ACCUMULATED',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
}

export enum WritersPaymentStatusValue {
  PENDING = 'รอดำเนินการ',
  CUMULATIVE = 'ยอดค้างโอน',
  ACCUMULATED = 'โอนเงินแล้ว',
  COMPLETE = 'โอนเงินแล้ว',
  ERROR = 'ERROR',
}
